export default class GetAllTipoServicio {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute() {
    try {
      const tipoServicios = await this.#repository.getAllTipoServicio()
      return tipoServicios
    } catch (error) {
      console.error('Error al obtener todas las asignaciones de personal a remesas:', error)
      throw error
    }
  }
}
